import { GraphQLQueryClass } from "@harea/component";
import { TContract } from "@harea/component";
export class ContractManagerQuery
    implements GraphQLQueryClass<TContract, TResponse>
{
    public queryKey: string = "App.bo.ContractManagerQuery";
    public gql: string = `
    query ContractManagerQuery ($data: JSONObject, $leaveTypeDesignation: String!) {
        contract(filter: { data: $data }) {
            id
            jobPosition {
                id
                value
                valueKey
            }
            leaveBalance {
                id
                availableSoldeBalance
                accruedSolde
                daysEligible
                initialBalance
                congeSolde: getCongeSolde
                getRemainingQuota(type: $leaveTypeDesignation)
                yearlyAllowances {
                    id
                    year
                    amount
                    timeOffType {
                        id
                        designation
                    }
                }
            }    
        }
    }                   
    `;
    variables?: any;
    constructor(variables?: any) {
        this.variables = {
            ...variables,
            data: {
                ...variables.data,
                "isActive": true
            },
            leaveTypeDesignation: variables.leaveTypeDesignation ?? ''
        };
    }
    mapFn(data: TResponse): TContract {
        return data.contract;
    }
}

export type TResponse = {
    contract: TContract
}